// src/components/landing/FinalCTA.tsx
'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden border-y border-border/60 px-5 py-16 md:px-10 md:py-20">
      {/* Gradient background */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 bg-brand/5" />

      <div className="mx-auto max-w-3xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
          Start your <span className="text-brand-ink">SAT journey</span> today
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-muted-foreground md:text-lg">
          {/* "Free during beta" contradicted the permanent free tier promised
              everywhere else (go-live audit) — the free tier is not temporary. */}
          Free tier forever. Built around the official Digital SAT format.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button
            asChild
            size="lg"
            className="bg-brand font-semibold text-on-brand hover:bg-brand-hover"
          >
            <Link href="/try" className="inline-flex items-center gap-2">
              Start Free Diagnostic
              <ArrowRight className="h-4 w-4" aria-hidden />
            </Link>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="border-border bg-card/60 text-foreground hover:bg-card"
          >
            <Link href="/pricing">View Pricing</Link>
          </Button>
        </div>
        <p className="mt-4 text-xs text-muted-foreground">
          No credit card required • Free tier forever
        </p>
      </div>
    </section>
  )
}
